export default __webpack_public_path__ + "static/01-03-prepare-differentiate-91382af40f6f6e700d752adfed857c74.mp4";